<button
  mat-raised-button
  [ngClass]="ngClass"
  (click)="location.back()"
>
  <mat-icon class="valign-middle">arrow_back</mat-icon>
  Back
</button>
